<template>
<div class='ml1x mr1x pt1x h16x posR'>
	<ChartLine ref="chartLine"
						 :data="ChartData"
						 :option="defChartMonthOption"
						 :chartClass="'h13x'"
						 @DataHover="data=>{this.$emit('DataHover',data)}"
						 v-if="ActiveIndex==0"></ChartLine>
	<ChartColumn ref="chartColumn"
							 :data="ChartData"
							 :option="defChartMonthOption"
							 :chartClass="'h13x'"
						 @DataHover="data=>{this.$emit('DataHover',data)}"
							 class="h13x"
							 v-else></ChartColumn>
</div>
</template>
<script>
import * as equipmentApi from '@/api/maintain/plant/list';
import ChartLine from '@/components/common/chart/ChartLine.vue';
import ChartColumn from '@/components/common/chart/ChartColumn.vue';
import * as lib from '@/util/lib.js';
import { getLanguageStr } from '@/util/language.js';
export default {
	name: 'generateChart',
	components: { ChartLine, ChartColumn },
	props: {
		ActiveIndex: {
			type: Number,
			default: 0
		},
		basicInfo: {
			type: Object,
			default: {}
		},
		time: {
			// type: Object,
			default: () => new Date()
		},
		timeZoneCode: {
			type: String,
			default: stage.time.timeZoneCode
		},
		stationId: {
			type: [String, Number],
			default: ''
		},
		systemId: {
			type: [String, Number],
			default: ''
		},
		level: {
			type: [String, Number],
			default: ''
		}
	},
	watch: {
		ActiveIndex (v) {

		}
	},
	data () {
		return {
			ChartData: [],
			chartList: [],
			defChartMonthOption: {},
			detailData: {},
			tempData: [],
			installedCapacity: null,
			timeChoose: [{
				datepicker: getLanguageStr('cmd93', '日'),
				format: 'YYYY/MM/DD',
				type: 'day'
			}, {
				datepicker: getLanguageStr('cmd95', '月'),
				format: 'YYYY/MM',
				type: 'month'
			}, {
				datepicker: getLanguageStr('cmd96', '年'),
				format: 'YYYY',
				type: 'year'
			}, {
				datepicker: getLanguageStr('cmd97', '总'),
				format: 'YYYY',
				type: 'all'
			}]
		};
	},
	methods: {
		getLanguageStr,
		floatFix: lib.floatFix,
		timeFormat: lib.timeFormat,
		getTypeText: lib.getTypeText,
		convertData: lib.convertData,
		mz () {
			return mz.tz(this.basicInfo.region.timezone)._offset * 60 * 1000; //
		},
		// 获取天数
		_getCountDays () {
			let curDate = _.cloneDeep(this.time);
			// let curMonth =curDate.getMonth()
			// curDate.setMonth(curMonth+1)
			// curDate.setDate(0);
			// return curDate.getDate()
			let curMonth = curDate.getMonth() + 1;
			let curYear = curDate.getFullYear();
			return new Date(curYear, curMonth, 0).getDate();
		},
		// 曲线图
		_showChart () {
			this.detailData = {};
			this.isChart = true;
			this.chartList = {};
			for (let attr in this.proportion) {
				this.proportion[attr] = 0;
			}
			// 日曲线图
			if (this.ActiveIndex == 0) { // 日
				this.chartList = [
					{
						name: getLanguageStr('word176', '发电功率'),
						type: 'generationPower',
						selected: true,
						isBeingSelected: true,
						default: true,
						unit: 'W',
						data: []
					}
				];
				this._chartDay();
			} else if (this.ActiveIndex == 1) { // 月图表
				let dateNum = this._getCountDays();
				this.chartList = [
					{
						name: getLanguageStr('word358', '当日发电量'),
						unit: 'kWh',
						type: 'generationValue',
						selected: true,
						isBeingSelected: true,
						default: true,
						data: new Array(dateNum)
					}
				];
				this._chartMonth();
			} else if (this.ActiveIndex == 2) { // 年
				this.chartList = [
					{
						name: getLanguageStr('word359', '当月发电量'),
						unit: 'kWh',
						type: 'generationValue',
						selected: true,
						isBeingSelected: true,
						default: true,
						data: new Array(12)
					}
				];
				this._chartYear();
			} else if (this.ActiveIndex == 3) { // 总
				this._totalData();
			}
		},
		resetChart () {
			this.detailData = {};
			this.tempData = [];
			this.chartData = [];
		},
			 // 日图表数据
		_chartDay () {
			this.$refs.chartLine.showLoading();
			Promise.all([this.powerDay(), this.powerDayTemp()]).then(response => {
				if (this.timeChoose[this.ActiveIndex].type == 'day') { // 防止快速切换导致hideLoading()方法不能执行
					this.resetChart();
					if (this.$refs.chartLine) this.$refs.chartLine.hideLoading();
					this.isChart = false;
					this.detailData = response[0];
					this.tempData = response[1];
					if (response[0].records.length == 0 && response[1].length == 0) {
						this.ChartData = [];
						this.$emit('LastData', []);
					} else {
						this._getDayData();
					}
				}
			}, error => {
				if (this.$refs.chartLine) this.$refs.chartLine.hideLoading();
				this.isChart = false;
				!_.isEmpty(error) && this.$notify(error);
			});
			// equipmentApi.cancelRequest()
		},
		// 日图表其他数据
		powerDay () {
			let requestId;
			let chooseDay = {
				'year': new Date(this.time).getFullYear(),
				'month': new Date(this.time).getMonth() + 1,
				'day': new Date(this.time).getDate()
			};
			if (this.level == 0) {
				requestId = this.stationId;
			} else {
				requestId = this.systemId;
			}
			return new Promise((resolve, reject) => {
				equipmentApi.PowerDayHistory(requestId, chooseDay).then(res => {
					resolve(res);
				}, error => {
					reject(error);
				});
			});
		},
		 // 日图表温度接口
		powerDayTemp () {
			let request = {
				'year': new Date(this.time).getFullYear(),
				'month': new Date(this.time).getMonth() + 1,
				'day': new Date(this.time).getDate(),
				'regionNationId': this.basicInfo.region.nationId,
				'regionLevel1': this.basicInfo.region.level1,
				'regionLevel2': this.basicInfo.region.level2,
				timezone: this.basicInfo.region.timezone
			};
			return new Promise((resolve, reject) => {
				equipmentApi.WeatherDayHistory(request).then(res => {
					resolve(res);
				}, error => {
					reject(error);
				});
			});
		},
		// 整合日图表数据
		_getDayData () {
			if (this.detailData.records.length > 0) {
				let chartData = [];
				chartData = _.cloneDeep(this.chartList).filter(el => el.selected == true);
				/// //////////////////////////////////////////////////////////////////////////
				// chartData.push({//加入天气
				// 	name:"天气",
				// 	type:"weatherPic",
				// 	dataType:"weatherPic"
				// });
				for (let attr in chartData) {
					chartData[attr].data = [];
					if (chartData[attr].type == 'weatherPic') { // 处理天气类型
						this.tempData.forEach(val => {
							chartData[attr].data.push([val.datetime * 1000 + this.mz(), null, val[chartData[attr].type]]);
						});
					} else if (chartData[attr].type == 'temperature') {
						if (this.tempData.length) {
							this.tempData.forEach(val => {
								chartData[attr].data.push([val.datetime * 1000 + this.mz(), val.temp]);
							});
						}
					} else {
						if (this.detailData.records.length) {
							this.detailData.records.forEach((val, index) => {
								chartData[attr].data.push([val.dateTime * 1000 + this.mz(), val[chartData[attr].type]]);
							});
							chartData[attr].data = lib.sortData(chartData[attr].data, {byKey: 0});
						}
					}
				}
				this.ChartData = chartData;
				let yTitle = [];
				for (let attr in this.ChartData) {
					if (this.ChartData[attr].unit) {
						if (yTitle.indexOf(this.ChartData[attr].unit) <= 0) {
							yTitle.push(this.ChartData[attr].unit);
						}
						this.ChartData[attr].yAxis = yTitle.indexOf(this.ChartData[attr].unit);
					} else this.ChartData[attr].yAxis = 0;
					delete this.ChartData[attr].default;
					delete this.ChartData[attr].selected;
					delete this.ChartData[attr].type;
				}
				if (yTitle.length == 0) {
					yTitle = [''];
				}
				this.defChartMonthOption = { // d
					yTitle: yTitle,
					opposite: true,
					startDate: this.time.getTime()
				};
			} else {
				this.ChartData = [];
			}
			if (this.ChartData.length) { // 输出最后一条数据
				this.$emit('LastData', this.ChartData[0].data.slice(this.ChartData[0].data.length - 1)[0]);
			} else this.$emit('LastData', []);
		},
		 // 月图表其他数据
		powerMonth () {
			let requestId;
			let chooseDay = {
				'year': new Date(this.time).getFullYear(),
				'month': new Date(this.time).getMonth() + 1
			};
			if (this.level == 0) {
				requestId = this.stationId;
			} else {
				requestId = this.systemId;
			}
			return new Promise((resolve, reject) => {
				equipmentApi.PowerMonthHistory(requestId, chooseDay).then(res => {
					resolve(res);
				}, error => {
					reject(error);
				});
			});
		},
		// 月图表温度接口
		powerMonthTemp () {
			let request = {
				'year': new Date(this.time).getFullYear(),
				'month': new Date(this.time).getMonth() + 1,
				'regionNationId': this.basicInfo.region.nationId,
				'regionLevel1': this.basicInfo.region.level1,
				'regionLevel2': this.basicInfo.region.level2,
				timezone: this.basicInfo.region.timezone
			};
			return new Promise((resolve, reject) => {
				equipmentApi.WeatherMonthHistory(request).then(res => {
					resolve(res);
				}, error => {
					reject(error);
				});
			});
		},
		// 月图表数据
		_chartMonth () {
			this.$refs.chartColumn.showLoading();
			Promise.all([this.powerMonth(), this.powerMonthTemp()]).then(response => {
				if (this.timeChoose[this.ActiveIndex].type == 'month') { // 防止快速切换导致hideLoading()方法不能执行
					this.resetChart();
					if (this.$refs.chartLine) this.$refs.chartColumn.hideLoading();
					this.isChart = false;
					this.detailData = response[0];
					this.tempData = response[1];
					if (response[0].records.length == 0 && response[1].length == 0) {
						this.ChartData = [];
						this.$emit('LastData', []);
					} else {
						this._getMonthData();
					}
				}
			}, error => {
				if (this.$refs.chartLine) this.$refs.chartColumn.hideLoading();
				this.isChart = false;
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		// 整合月数据
		_getMonthData () {
			if (this.detailData.records.length > 0) {
				let chartData = [];
				chartData = _.cloneDeep(this.chartList).filter(el => el.selected == true);
				let dateNum = this._getCountDays();
				for (let attr in chartData) {
					chartData[attr].data = new Array(dateNum);
					$.each(chartData[attr].data, (index) => {
						chartData[attr].data[index] = null;
					});
					if (chartData[attr].type == 'weatherPic') { // 处理天气类型
						this.tempData.forEach(val => {
							chartData[attr].data[new Date(val.datetime * 1000 + this.mz()).getDate() - 1] = val.weatherPic;
						});
					} else if (chartData[attr].type == 'temperature') {
						if (this.tempData.length) {
							this.tempData.forEach(val => {
								chartData[attr].data[new Date(val.datetime * 1000 + this.mz()).getDate() - 1] = Number(val.temp);
							});
						}
					} else if (chartData[attr].type == 'pr') {
						this.detailData.records.map((val, index) => {
							chartData[attr].data[parseInt(val.day) - 1] = Number(val[chartData[attr].type]) * 100;
						});
					} else {
						this.detailData.records.map((val, index) => {
							chartData[attr].data[parseInt(val.day) - 1] = Number(val[chartData[attr].type]);
						});
					}
				}
				this.ChartData = chartData;
				let yTitle = [];
				for (let attr in this.ChartData) {
					if (this.ChartData[attr].unit) {
						if (yTitle.indexOf(this.ChartData[attr].unit) <= 0) {
							yTitle.push(this.ChartData[attr].unit);
						}
						this.ChartData[attr].yAxis = yTitle.indexOf(this.ChartData[attr].unit);
					}
					delete this.ChartData[attr].default;
					delete this.ChartData[attr].selected;
					delete this.ChartData[attr].type;
				}
				if (yTitle.length == 0) {
					yTitle = [''];
				}
				this.defChartMonthOption = (function () { // 默认月图表参数
					let obj = { // d
						yTitle: yTitle,
						timeType: 'month',
						opposite: true,
						xCategories: new Array(dateNum)
					};
					$.each(obj.xCategories, function (index) {
						obj.xCategories[index] = index + 1;
					});
					return obj;
				}());
			} else {
				this.ChartData = [];
			}
			if (this.ChartData.length) { // 输出最后一条数据
				let arr = [...this.ChartData[0].data];
				let lastIndex = 0;
				arr = arr.reverse();
				$.each(arr, function (index) { // 遍历所有数据找出有数据的index
					if (this > 0) {
						lastIndex = index;
						return false;
					}
				});
				arr = [arr.length - lastIndex, arr[lastIndex]];
				this.$emit('LastData', arr);
			} else this.$emit('LastData', []);
		},
		_timePicker (item, index) {
			// this.$refs.DeviceDetailParam.showParam = false
			// this.CHANGE(index)
			// this.ActiveIndex = index
			this.$nextTick(() => {
				this._showChart();
			});
		},
		// 年图表数据
		_chartYear () {
			this.$refs.chartColumn.showLoading();
			let requestId;
			let chooseYear = {
				'year': new Date(this.time).getFullYear()
			};
			if (this.level == 0) {
				requestId = this.stationId;
			} else {
				requestId = this.systemId;
			}
			// equipmentApi.cancelRequest()
			equipmentApi.PowerYearHistory(requestId, chooseYear).then(response => {
				if (this.timeChoose[this.ActiveIndex].type == 'year') { // 防止快速切换导致hideLoading()方法不能执行
					this.resetChart();
					this.isChart = false;
					if (!response) return;
					if (this.$refs.chartLine) this.$refs.chartColumn.hideLoading();
					this.detailData = response;
					if (this.detailData.records.length == 0) {
						this.ChartData = [];
						this.$emit('LastData', []);
					} else {
						this._getYearData();
					}
				}
			}, error => {
				!_.isEmpty(error) && this.$notify(error);
				if (this.$refs.chartLine) this.$refs.chartColumn.hideLoading();
				this.isChart = false;
			});
		},
		_getYearData () {
			if (this.detailData.records.length > 0) {
				let chartData = [];
				chartData = _.cloneDeep(this.chartList).filter(el => el.selected == true);
				for (let attr in chartData) {
					chartData[attr].data = new Array(12);
					$.each(chartData[attr].data, (index) => {
						chartData[attr].data[index] = null;
					});
					if (chartData[attr].type == 'pr') {
						 this.detailData.records.map((val, index) => {
							chartData[attr].data[parseInt(val.month) - 1] = Number(val[chartData[attr].type]) * 100;
						});
					} else {
						 this.detailData.records.map((val, index) => {
							chartData[attr].data[parseInt(val.month) - 1] = Number(val[chartData[attr].type]);
						});
					}
				}
				this.ChartData = chartData;
				let yTitle = [];
				for (let attr in this.ChartData) {
					yTitle.push(this.ChartData[attr].unit);
					if (attr > 0) {
						this.ChartData[attr].yAxis = Number(attr);
					}
					delete this.ChartData[attr].default;
					delete this.ChartData[attr].selected;
					delete this.ChartData[attr].type;
				}
				this.defChartMonthOption = (function () { // 默认月图表参数
					let obj = { // d
						yTitle: yTitle,
						timeType: 'year',
						opposite: true,
						xCategories: new Array(12)
					};
					$.each(obj.xCategories, function (index) {
						obj.xCategories[index] = index + 1;
					});
					return obj;
				}());
			} else {
				this.ChartData = [];
			}
			if (this.ChartData.length) { // 输出最后一条数据
				let arr = [...this.ChartData[0].data];
				let lastIndex = 0;
				arr = arr.reverse();
				$.each(arr, function (index) { // 遍历所有数据找出有数据的index
					if (this > 0) {
						lastIndex = index;
						return false;
					}
				});
				arr = [arr.length - lastIndex, arr[lastIndex]];
				this.$emit('LastData', arr);
			}
		},
		 // 总图表数据
		_totalData () {
			this.$refs.chartColumn.showLoading();
			let requestId;
			let chooseTotal = {
				'startYear': 2000,
				'endYear': new Date(this.time).getFullYear()
			};
			if (this.level == 0) {
				requestId = this.stationId;
			} else {
				requestId = this.systemId;
			}
			// equipmentApi.cancelRequest()
			equipmentApi.PowerTotalHistory(requestId, chooseTotal).then(response => {
				if (this.timeChoose[this.ActiveIndex].type == 'all') { // 防止快速切换导致hideLoading()方法不能执行
					this.ChartData = [];
					if (this.$refs.chartLine) this.$refs.chartColumn.hideLoading();
					this.isChart = false;
					if (!response) return;
					this.detailData = response;
					if (this.detailData.records.length == 0) {
						this.ChartData = [];
					} else {
						let startYear = [];
						for (let attr in this.detailData.records) {
							startYear.push(this.detailData.records[attr].year);
						}
						startYear = lib.sortData(startYear)[0]; // 获取最小的年份
						let endYear = lib.timeFormat(new Date(), 'inc', '%Y'); // 获取当年年份
						let YearNum = Number(endYear) - Number(startYear) + 1; // X轴总数
						this.rangeDate = [new Date(String(startYear)), new Date(endYear)];
						this.chartList = [
							{
								name: getLanguageStr('word360', '当年发电量'),
								unit: 'kWh',
								type: 'generationValue',
								selected: true,
								isBeingSelected: true,
								default: true,
								data: new Array(YearNum)
							}
						];
						this._getTotalData();
					}
				}
			}, error => {
				if (this.$refs.chartLine) this.$refs.chartColumn.hideLoading();
				!_.isEmpty(error) && this.$notify(error);
				this.isChart = false;
			});
		},
		// 整合总图表数据
		_getTotalData () {
			if (this.detailData.records.length > 0) {
				let startYear = [];
				for (let attr in this.detailData.records) {
					startYear.push(this.detailData.records[attr].year);
				}
				startYear = lib.sortData(startYear)[0]; // 获取最小的年份
				let endYear = lib.timeFormat(new Date(), 'inc', '%Y'); // 获取当年年份
				let YearNum = Number(endYear) - Number(startYear) + 1; // X轴总数
				this.rangeDate = [new Date(String(startYear)), new Date(endYear)];

				let chartData = [];
				chartData = _.cloneDeep(this.chartList).filter(el => el.selected == true);
				for (let attr in chartData) {
					chartData[attr].data = new Array(YearNum);
					$.each(chartData[attr].data, (index) => {
						chartData[attr].data[index] = null;
					});
					if (chartData[attr].type == 'pr') {
						this.detailData.records.map((val, index) => {
							chartData[attr].data[parseInt(val.year) - Number(startYear)] = Number(val[chartData[attr].type]) * 100;
						});
					} else {
						this.detailData.records.map((val, index) => {
							chartData[attr].data[parseInt(val.year) - Number(startYear)] = Number(val[chartData[attr].type]);
						});
					}
				}
				this.ChartData = chartData;
				let yTitle = [];
				for (let attr in this.ChartData) {
					yTitle.push(this.ChartData[attr].unit);
					if (attr > 0) {
						this.ChartData[attr].yAxis = Number(attr);
					}
					delete this.ChartData[attr].default;
					delete this.ChartData[attr].selected;
					delete this.ChartData[attr].type;
				}
				this.defChartMonthOption = (function () { // 默认月图表参数
					let obj = { // d
						yTitle: yTitle,
						timeType: 'all',
						opposite: true,
						xCategories: new Array(YearNum)
					};
					$.each(obj.xCategories, function (index) {
						obj.xCategories[index] = index + Number(startYear);
					});
					return obj;
				}());
			} else {
				this.ChartData = [];
			}
			// for(let attr in this.chartList){
			// 	$.each(this.chartList[attr].data,(index)=>{
			// 		this.chartList[attr].data[index]=null
			// 	})
			// 	this.detailData.records.map((val,index)=>{
			// 		this.chartList[attr].data[parseInt(val.year)-Number(startYear)]=Number(val[attr])
			// 	})
			// 	this.ChartData.push(this.chartList[attr])
			// }
			// this.defChartMonthOption=function(){//默认月图表参数
			// 	let obj={ //d
			// 		yTitle:['kWh','h','kWh/㎡','%'],
			// 		timeType:"all",
			// 		opposite:true,
			// 		xCategories:new Array(YearNum)
			// 	}
			// 	$.each(obj.xCategories,function(index){
			// 		obj.xCategories[index]=index+Number(startYear);
			// 	});
			// 	return obj;
			// }()
			if (this.ChartData.length) { // 输出最后一条数据
				let arr = [...this.ChartData[0].data];
				let lastIndex = 0;
				arr = arr.reverse();
				$.each(arr, function (index) { // 遍历所有数据找出有数据的index
					if (this > 0) {
						lastIndex = index;
						return false;
					}
				});
				arr = [this.defChartMonthOption.xCategories[arr.length - 1 - lastIndex], arr[lastIndex]];
				this.$emit('LastData', arr);
			}
		}
	},
	mounted () {
		this.$nextTick(() => {
			this.installedCapacity = this.basicInfo.installedCapacity;
			this._showChart();
		});
	}
};
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/GenerateChartForLayout.vue